import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-offboarding-requirements-dialog',
  templateUrl: './offboarding-requirements-dialog.component.html',
  styleUrls: ['./offboarding-requirements-dialog.component.scss']
})
export class OffboardingRequirementsDialogComponent implements OnInit {
  isCreating = false;
  chosenItem;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OffboardingRequirementsDialogComponent>
  ) { }

  ngOnInit(): void {
  }

  onCreationChange(e) {
    this.isCreating = e;
  }

  toggleCreationMode() {
    this.isCreating = true;
  }

  closeDialog(e) {
    if (!e) {
      this.close();
    } else {
      this.close(e);
    }
  }

  close(data?): void {
    this.dialogRef.close(data);
  }
}
